import HttpClienteToken from '../../services/HttpClientToken';

import { TipoTramiteProps } from '../../interfaces/catalogos/TipoTramiteInterface';

export const TiposTramite = () => {

    return new Promise<TipoTramiteProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoTramite/', token)
            .then( ({ data } : { data : TipoTramiteProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerTipoTramites = () => {

    return new Promise<TipoTramiteProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoTramite/ObtenerTipoTramites', token)
            .then( ({ data } : { data : TipoTramiteProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarTipoTramite = ( params: TipoTramiteProps ) => {

    return new Promise<TipoTramiteProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoTramite/Actualizar', params, token)
            .then( ({ data } : { data : TipoTramiteProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoTramite: 0,                 
                    descripcion: '',
                    activo: false,     
                });
            });
        }

    });

}

export const AgregarTipoTramite = ( params: TipoTramiteProps ) => {

    return new Promise<TipoTramiteProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoTramite/Agregar', params, token)
            .then( ({ data } : { data : TipoTramiteProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoTramite: 0,
                    descripcion: '',
                    activo: false,    
                });
            });
        }

    });

}